import React, { lazy } from 'react';
import { AuthRoute } from '../auth/components';
import config from "@config";


const WidgetCalculator = lazy(() => import('./pages/WidgetCalculator'));


const calculatorsModule = {
  routes: [
    <AuthRoute
      key="stamp-duty"
      exact
      path="/calculators/stamp-duty"
      component={WidgetCalculator}
      headerType={'private'}
      componentProps={{ title: 'Stamp duty calculator', partnerId: config.WIDGET_PARTNER_ID, widgetId: 'stamp-duty' }}
    />,
    <AuthRoute
      key="loan-repayment"
      exact
      path="/calculators/loan-repayment"
      component={WidgetCalculator}
      headerType={'private'}
      componentProps={{ title: 'Loan repayment calculator', partnerId: config.WIDGET_PARTNER_ID, widgetId: 'loan-repayment' }}
    />,
    <AuthRoute
      key="extra-repayment"
      exact
      path="/calculators/extra-repayment"
      component={WidgetCalculator}
      headerType={'private'}
      componentProps={{ title: 'Extra repayment calculator', partnerId: config.WIDGET_PARTNER_ID, widgetId: 'extra-loan-repayment' }}
    />,
    <AuthRoute
      key="income-taxes"
      exact
      path="/calculators/income-taxes"
      component={WidgetCalculator}
      headerType={'private'}
      componentProps={{ title: 'Income tax calculator', partnerId: config.WIDGET_PARTNER_ID, widgetId: 'income-taxes-calculator' }}
    />,
    <AuthRoute
      key="offset-account"
      exact
      path="/calculators/offset-account"
      component={WidgetCalculator}
      headerType={'private'}
      componentProps={{ title: 'Offset account calculator', partnerId: config.WIDGET_PARTNER_ID, widgetId: 'offset-account-calculator' }}
    />,
  ]
};

export default calculatorsModule;
